export const API_URL = 'https://api.freecurrencyapi.com/v1/';
export const API_KEY = 'fca_live_mOcH4n4zPK5SwCPrD6pGUaKMDN7SeApDPyYmrWBJ';